export const UPDATE_USER_SITES = "bonfire/userSites/UPDATE_USER_SITES";
export const LOAD_USER_SITES_COMPLETE =
  "bonfire/userSites/LOAD_USER_SITES_COMPLETE";
